import { Flex } from "components/LEGACY/styled-components/Flex"
import EmailSignUpForm from "components/utils/EmailSignUpForm"
import PatternPageContainer from "components/utils/PatternPageContainer"
import SocialLoginButtons from "components/utils/SocialLoginButtons"
import VerticalDivider from "components/utils/VerticalDivider"
import { useUrlQuery } from "hooks/localstate/url/useUrlQuery"
import getpackedLogo from "images/getpacked_Logo_schwarz.svg"
import Image from "next/image"
import Link from "next/link"

const SignUp = () => {
  const [defaultEmail] = useUrlQuery("email")

  return (
    <>
      <style jsx>{`
        .container {
          display: grid;
          justify-items: center;
          position: relative;
          grid-gap: 10px;
        }
        .linkContainer {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
        }
      `}</style>
      <PatternPageContainer light>
        <Flex style={{ height: "100%" }} justifyCenter alignCenter>
          <div className="container">
            <Image src={getpackedLogo} alt={"getpacked logo"} layout="fixed" />

            <h1 style={{ color: "black" }}>Registriere dich jetzt</h1>
            <EmailSignUpForm defaultEmail={defaultEmail} />
            {/* <Link href="/forgot-password">Passwort vergessen?</Link> */}
            <div className="linkContainer">
              <Link href="/login">Stattdessen anmelden</Link>
              <Link href="/reset-password">Passwort vergessen?</Link>
            </div>

            <VerticalDivider>oder</VerticalDivider>
            <SocialLoginButtons />

            <hr />
          </div>
        </Flex>
      </PatternPageContainer>
    </>
  )
}

export default SignUp
